/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { RichText, isChildOfContainerContext } from '../helpers/react'
import { Image } from './image'

const ImageTextModule = ({
  content = {},
  image = {},
  layout = 'image text',
  layoutDirection,
  colorBlock = undefined,
  critical,
}) => {
  const mobileTemplate = `
    "image"
    "text"
    `

  return (
    <isChildOfContainerContext.Provider value={true}>
      <div sx={{ variant: 'layout.container.lg' }}>
        <div
          sx={{
            display: 'grid',
            gridTemplateColumns: ['1fr', 'repeat(2, minmax(0, 1fr))'],
            gridTemplateAreas: [mobileTemplate, `"${layout}"`],
            columnGap: [null, 'clamp(24px, 5vw, 80px)'],
            rowGap: ['lg', '0'],
            alignItems: 'center',
            justifyItems: 'center',
            pb: colorBlock && layoutDirection === 'left' ? ['md'] : '0',
            pt: colorBlock && layoutDirection === 'right' ? ['md'] : '0',
            px: [null, 'sm', null],
          }}
        >
          <div
            sx={{
              position: 'relative',
              gridArea: 'image',
              width: '100%',
              px: ['md', null],
              py: ['xl', null],
            }}
          >
            <Image image={image} critical={critical} />
            <If condition={colorBlock}>
              <div
                aria-hidden
                sx={{
                  position: 'absolute',
                  zIndex: '-1',
                  height: ['calc(100% + 24px)', 'calc(100% - 56px)'],
                  width: ['calc(100% + 24px)', '100%'],
                  ...colorBlock,
                }}
              />
            </If>
          </div>
          <div
            sx={{
              gridArea: 'text',
              px: ['xxxs', '0'],
            }}
          >
            <RichText content={content} />
          </div>
        </div>
      </div>
    </isChildOfContainerContext.Provider>
  )
}

export default ImageTextModule
